import { Grid, Typography } from '@mui/material';
import type { Path } from 'react-hook-form';
import {
  ColorPickerWidget,
  NumberInputWidget,
  SelectDropdownWidget,
  SwitchButtonWidget,
} from 'src/components/widget';
import { FONT_FAMILY_OPTIONS } from 'src/constants';
import { useGetProjectConfig } from 'src/hooks';
import { lang } from 'src/utils';

import { generateBadgeSizeOption } from './ComboStyleImageBadge.helper';
import { ComboStyleImageBadgeProps } from './ComboStyleImageBadge.interface';

export const ComboStyleImageBadge = (props: ComboStyleImageBadgeProps) => {
  const { data: projectConfig } = useGetProjectConfig();

  const projectFonts =
    projectConfig?.fonts?.map((item) => ({
      label: item.name,
      value: item.name,
    })) ?? [];
  const mappedFonts =
    projectFonts.length > 0 ? projectFonts : FONT_FAMILY_OPTIONS;

  const handleBadgeChange =
    (field: Path<ComboStyleImageBadgeProps['badge']>) => (value: any) => {
      props.handleOnChange(value, field);
    };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography fontWeight={400}>{lang.imageBadging}</Typography>
      </Grid>
      <Grid item xs={12}>
        <SwitchButtonWidget
          value={props.badge?.visible}
          onChange={handleBadgeChange('visible')}
        />
      </Grid>
      {props.badge?.visible && (
        <>
          <Grid item xs={12}>
            <SelectDropdownWidget
              label={lang.fontFamily}
              value={props.badge?.style?.font}
              selectOptions={mappedFonts}
              onChange={handleBadgeChange('style.font')}
            />
          </Grid>
          <Grid item xs={6}>
            <NumberInputWidget
              label={lang.fontSize}
              value={props.badge?.style?.fontSize}
              onChange={handleBadgeChange('style.fontSize')}
              options={{ suffix: 'px' }}
            />
          </Grid>
          <Grid item xs={6}>
            <ColorPickerWidget
              label={lang.fontColor}
              value={props.badge?.style?.fontColor}
              onChange={handleBadgeChange('style.fontColor')}
              colorPickerMode="block"
              pickerWrapperStyle={{ left: '-50px' }}
            />
          </Grid>
          <Grid item xs={6}>
            <SelectDropdownWidget
              label={lang.badgeSize}
              value={props.badge?.style?.badgeSize}
              selectOptions={generateBadgeSizeOption(150)}
              onChange={handleBadgeChange('style.badgeSize')}
            />
          </Grid>
          <Grid item xs={6}>
            <ColorPickerWidget
              label={lang.badgeColor}
              value={props.badge?.style?.backgroundColor}
              onChange={handleBadgeChange('style.backgroundColor')}
              colorPickerMode="block"
              pickerWrapperStyle={{ left: '-50px' }}
            />
          </Grid>
          <Grid item xs={6}>
            <NumberInputWidget
              label={lang.xAxis}
              value={props.badge?.style?.left}
              onChange={handleBadgeChange('style.left')}
              options={{ suffix: 'px' }}
            />
          </Grid>
          <Grid item xs={6}>
            <NumberInputWidget
              label={lang.yAxis}
              value={props.badge?.style?.top}
              onChange={handleBadgeChange('style.top')}
              options={{ suffix: 'px' }}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
